import React, { useCallback, useState } from 'react';

import Button, { LoadingButton } from '@atlaskit/button';
import SectionMessage from '@atlaskit/section-message';
import { closeDialog } from 'src/services/jira';
import useAllWebhooksValidationTasks from 'src/services/webhooks/useAllWebhooksValidationTasks';

import { locationReload } from 'src/lib/history';

import WebhooksTasksTable from 'src/views/Admin/Modals/components/WebhooksTasksTable';
import CenteredSpinner from 'src/views/components/CenteredSpinner';
import ErrorMessage from 'src/views/components/ErrorMessage';
import ModalButtons from 'src/views/components/ModalButtons';
import ModalContainer from 'src/views/components/ModalContainer';

import ScopeSelector, { actionTypeOptions, scopeOptions } from './ScopeSelector';

const NoActionsMessage = () => {
  return (
    <SectionMessage>
      Nothing to do. Webhooks are in sync.
    </SectionMessage>
  );
};

const DataPresentation = () => {
  const [isRunning, setIsRunning] = useState(false);
  const [actionType, setActionType] = useState('fix');
  const [actionScope, setActionScope] = useState('both');
  const [isComplete, setIsComplete] = useState(false);
  const { loading, error, tasks } = useAllWebhooksValidationTasks({ actionScope, actionType });

  const actionLabel = `${actionTypeOptions.find(x => x.value === actionType).label} (${scopeOptions.find(x => x.value === actionScope).label})`;
  const onDone = useCallback(() => { setIsComplete(true); setIsRunning(false); }, []);

  const showNoActionsMessage = actionType === 'fix' && tasks.length === 0;
  const showPrimaryButton = !(showNoActionsMessage || isComplete);

  if (loading || error) {
    return (
      <div>
        {Boolean(error) && <ErrorMessage error={['Failed to load all webhooks', error]}/>}
        {Boolean(loading && !error) && <CenteredSpinner size="large"/>}
        <ModalButtons>
          <Button onClick={closeDialog}>Close</Button>
        </ModalButtons>
      </div>
    );
  }

  return (
    <div>
      <ScopeSelector
        isDisabled={isRunning || isComplete}
        actionScope={actionScope}
        actionType={actionType}
        setActionScope={setActionScope}
        setActionType={setActionType}
      />
      <hr style={{ margin: '10px' }}/>
      {!showNoActionsMessage && <WebhooksTasksTable tasks={tasks} isRunning={isRunning} onDone={onDone}/>}
      {showNoActionsMessage && <NoActionsMessage/>}
      <ModalButtons>
        <Button onClick={() => locationReload()} isDisabled={isRunning}>Reload</Button>
        <Button onClick={closeDialog}>{isComplete ? 'Close' : 'Cancel'}</Button>
        {showPrimaryButton && <LoadingButton appearance="primary" onClick={() => setIsRunning(true)} isLoading={isRunning}>{actionLabel}</LoadingButton>}
      </ModalButtons>
    </div>
  );
};

const ValidateWebhooksModal = () => {
  return (
    <ModalContainer title="Check webhooks">
      <DataPresentation/>
    </ModalContainer>
  );
};

export default ValidateWebhooksModal;
